<template>
  <div id="page-user-list">
    <div class="flex flex-wrap-reverse items-center data-list-btn-container">
      <div v-if="!readOnlyRole"
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push('/outlay-add-simple')">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">1. Upload International Invoices & Bon</span>
      </div>
      <div v-if="fileList.length - 1 > 0 && !readOnlyRole"
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="$router.push('/inputnextexpenses')">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">2. Encoding ({{ fileList.length - 1 }})</span>
      </div>
      <div
        class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-warning border border-solid border-warning"
        @click="openSendUnpaidEmailPopup">
        <feather-icon icon="MailIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-warning">Trimitere raport facturi neachitate (PDF) ({{ unpaidInvoices.length }})</span>
      </div>
    </div>
    <div class="vx-card p-6 mb-8">

      <div class="flex items-center justify-end mb-4">
        <label for="year-selector" class="mr-2 text-sm">Select Year:</label>
        <select id="year-selector" v-model="selectedYear" class="border border-solid rounded px-2 py-1 text-sm">
          <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
        </select>
      </div>
    </div>
    <div class="vx-card p-6 mb-8">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{
                operationsDataProcessed.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize
                  :
                  operationsDataProcessed.length }} of {{ operationsDataProcessed.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(250)">
                <span>250</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>


        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-button class="mb-4 md:mb-0 mr-2" color="danger" @click="filterNotPaid"
          v-if="searchQuery !== 'Not Paid'">Filter 'Not Paid'</vs-button>
        <vs-button class="mb-4 md:mb-0 mr-2" color="primary" @click="removeFilterNotPaid" v-else>Display All</vs-button>
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
          @input="updateSearchQuery" placeholder="Search..." />
        <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
      </div>
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
        :rowData="operationsDataProcessed" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
        :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true" :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />

    </div>


    <div class="vx-card p-6 mb-8">

      <div class="totals-container">
        <!-- Global Totals Section -->
        <div class="totals-section">
          <h3 class="totals-title">Overall Totals</h3>
          <div class="totals-content">
            <div class="totals-row">
              <span>ExVAT: <strong>{{ formatNumber(totals.EUR.totalExVAT) }} EUR</strong></span>
            </div>
            <div class="totals-row">
              <span>ExVAT: <strong>{{ formatNumber(totals.RON.totalExVAT) }} RON</strong></span>
            </div>
          </div>
          <div class="monthly-totals">
            <h4 class="monthly-title">By Month</h4>
            <div class="monthly-grid">
              <div v-for="(monthData, monthIndex) in totals.byMonth" :key="monthIndex" class="month-item">
                <div class="month-name">{{ months[monthIndex - 1] }}</div>
                <div class="month-values">
                  <div v-if="parseFloat(monthData.EUR.totalExVAT) > 0" class="month-value">
                    EUR: <strong>{{ formatNumber(monthData.EUR.totalExVAT) }}</strong>
                  </div>
                  <div v-if="parseFloat(monthData.RON.totalExVAT) > 0" class="month-value">
                    RON: <strong>{{ formatNumber(monthData.RON.totalExVAT) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Popup for sending unpaid invoices email -->
    <vs-popup title="Trimitere raport facturi neachitate (PDF)" :active.sync="popupSendEmail" class="unpaid-email-popup">
      <div ref="content" class="unpaid-email-popup-content">
        <div class="p-4">
          <div class="mb-4">
            <label class="block text-sm font-medium mb-2">Email destinatar:</label>
            <vs-input class="w-full" v-model="emailRecipient" placeholder="Introduceti email-ul destinatarului..." />
          </div>

          <!-- Summary box (same as PDF) -->
          <div class="unpaid-pdf-summary">
            Facturi: {{ unpaidInvoices.length }} &nbsp;&nbsp;|&nbsp;&nbsp; Total EUR: {{ formatNumber(unpaidTotals.EUR) }} &nbsp;&nbsp;|&nbsp;&nbsp; Total RON: {{ formatNumber(unpaidTotals.RON) }}
          </div>

          <!-- Table (same style as PDF: dark header, alternating rows) -->
          <div class="unpaid-pdf-table-wrap">
            <table class="unpaid-pdf-table">
              <thead>
                <tr class="unpaid-pdf-table-header">
                  <th>Furnizor</th>
                  <th>Factura</th>
                  <th>Data</th>
                  <th>Termen</th>
                  <th class="text-right">Suma</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, idx) in unpaidInvoicesPreview" :key="invoice.idoperation" :class="idx % 2 === 1 ? 'unpaid-pdf-row-alt' : ''" class="unpaid-pdf-row">
                  <td>{{ invoice.provider || '-' }}</td>
                  <td>{{ invoice.invoice_no || '-' }}</td>
                  <td>{{ formatDateSPV(invoice.data_creare) }}</td>
                  <td>{{ formatDeadline(invoice.date_delivery_desired) }}</td>
                  <td class="text-right">{{ parseFloat(invoice.amount_htva || 0).toFixed(2) }} {{ invoice.currency }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-if="unpaidInvoices.length > 100" class="unpaid-pdf-note">Se afiseaza primele 100 din {{ unpaidInvoices.length }} (email-ul va contine link pentru PDF-ul complet)</p>
          <p class="unpaid-pdf-footer">Xylo — {{ formatDateForPdfHeader() }}</p>
        </div>

        <div class="unpaid-pdf-actions">
          <vs-button color="danger" type="border" @click="popupSendEmail = false">Anulare</vs-button>
          <vs-button color="primary" @click="sendUnpaidInvoicesEmail" :disabled="!emailRecipient || unpaidInvoices.length === 0">Trimitere email</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import axios from 'axios';
import { parseStringPromise } from 'xml2js';

import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleBankList from '@/store/bank/moduleDataList.js'

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import moment from 'moment'
import { isAccountantOnly } from '@/helpers/roleAccess.js'


export default {
  components: {
    AgGridVue,
    vSelect,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data() {
    return {
      // Comptable (lecture seule) : pas de dépôt ni d'encodage de factures
      // étrangères / bons — seuls la consultation, le classement budget/payé
      // (fiche) et le rapport d'impayés lui sont ouverts.
      readOnlyRole: isAccountantOnly(),
      fileList: [],

      rates: [], // Taux EUR -> RON stockés ici
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      selectedMonth: new Date().getMonth() + 1, // Mois actuel par défaut (1-12)

      years: this.getYearsRange(), // Remplit la liste d'années
      selectedMonth: new Date().getMonth() + 1, // Mois actuel
      selectedYear: new Date().getFullYear(), // Année actuelle
      currentValue: null,
      searchQuery: '',
      // Email popup
      popupSendEmail: false,
      emailRecipient: '',
      // AgGrid
      gridApi: null,
      gridOptions: {},
      suppressSizeToFit: true,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'DATE',
          valueGetter: (params) => this.formatDateSPV(params.data.data_creare),
          filter: true,
          width: 150,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'INVOICE NO',
          valueGetter: function (params) {
            if (params.data.invoice_no) {
              return params.data.invoice_no
            }
            return 'N/A'
          },
          cellRendererFramework: 'CellRendererStatus',
          filter: true,
          width: 190,
        },
        {
          headerName: 'CUI SENDER',
          valueGetter: function (params) {
            if (params.data.detalii) {
              let cifBeneficiarRegex = /cif_emitent=(\d+)/;
              let match = params.data.detalii.match(cifBeneficiarRegex);
              let cifBeneficiar = match ? match[1] : null;
              if (cifBeneficiar) return cifBeneficiar
            }
            if (params.data.cif) return params.data.cif.replace("RO", "")
            //return params.data.cif.replace("RO","")
          },
          filter: true,
          width: 210
        },
        {
          headerName: 'SENDER',
          valueGetter: function (params) {
            if (params.data.provider) {
              return params.data.provider
            }
            return 'N/A'
          },
          cellRendererFramework: 'CellRendererStatus',
          filter: true,
          width: 280,
        },
        {
          headerName: 'ExVAT (EUR)',
          valueGetter: function (params) {
            if (params.data.currency === 'EUR') {
              return parseFloat(params.data.amount_htva || 0).toFixed(2);
            }
            return '';
          },
          filter: true,
          width: 145,
        },
        {
          headerName: 'ExVAT (RON)',
          valueGetter: function (params) {
            if (params.data.currency === 'RON') {
              return parseFloat(params.data.amount_htva || 0).toFixed(2);
            }
            return '';
          },
          filter: true,
          width: 145,
        },
        {
          headerName: 'IS PAID?',
          valueGetter: function (params) {
            if (params.data.paymentmeans && (params.data.paymentmeans == 1 || params.data.paymentmeans == 10)) {
              return 'Paid (Cash/POS)'
            }
            else if (params.data.cif && params.data.cif.replace("RO", "") === '2816464') return 'Paid (Cash/POS)'
            else if (params.data.cif && params.data.cif.replace("RO", "") === '2864518') return 'Paid (Cash/POS)'
            else if (params.data.cif && params.data.cif.replace("RO", "") === '18107744') return 'Paid (Cash/POS)'
            else if (params.data.count_transactions != 0) return 'Transaction YD' + params.data.idoperation + ' (' + parseFloat(params.data.count_transactions).toFixed(2) + ' ' + params.data.currency + ')'
            else if (params.data.ispaid) return 'Paid'
            return 'Not Paid'
          },
          filter: true,
          width: 210,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'BUDGET',
          field: 'budgetcategory', // Pas besoin de recalcul
          filter: true,
          width: 120,
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  computed: {
    totals() {
      return this.getTotals();
    },
    operationsDataProcessed() {
      return this.$store.state.BankList.downloadinvoicestreated.map(invoice => {
        // Pas de conversion, on garde les valeurs originales selon la devise
        const totalExVATEUR = invoice.currency === 'EUR'
          ? parseFloat(invoice.amount_htva || 0).toFixed(2)
          : '';

        const totalExVATRON = invoice.currency === 'RON'
          ? parseFloat(invoice.amount_htva || 0).toFixed(2)
          : '';

        return {
          ...invoice,
          totalExVATEUR,
          totalExVATRON,
        };
      });
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 250
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    },
    unpaidInvoices() {
      const excludedCifs = ['2816464', '2864518', '18107744'];
      return this.$store.state.BankList.downloadinvoicestreated
        .filter(invoice => {
          // Filter truly unpaid invoices
          const isPaidByCashPOS = invoice.paymentmeans && (invoice.paymentmeans == 1 || invoice.paymentmeans == 10);
          const isExcludedCif = invoice.cif && excludedCifs.includes(invoice.cif.replace('RO', ''));
          const hasTransactions = invoice.count_transactions && invoice.count_transactions != 0;
          const isMarkedPaid = invoice.ispaid;
          
          // Return only truly unpaid
          return !isPaidByCashPOS && !isExcludedCif && !hasTransactions && !isMarkedPaid;
        })
        .sort((a, b) => {
          // Sort by deadline (date_delivery_desired) ascending - oldest first
          const dateA = a.date_delivery_desired ? new Date(a.date_delivery_desired) : new Date('9999-12-31');
          const dateB = b.date_delivery_desired ? new Date(b.date_delivery_desired) : new Date('9999-12-31');
          return dateA - dateB;
        });
    },
    unpaidTotals() {
      return this.unpaidInvoices.reduce((totals, invoice) => {
        const amount = parseFloat(invoice.amount_htva) || 0;
        if (invoice.currency === 'EUR') {
          totals.EUR += amount;
        } else if (invoice.currency === 'RON') {
          totals.RON += amount;
        }
        return totals;
      }, { EUR: 0, RON: 0 });
    },
    unpaidInvoicesPreview() {
      return this.unpaidInvoices.slice(0, 100);
    }
  },
  watch: {
    selectedYear(newYear, oldYear) {
      // Ne pas déclencher lors de l'initialisation
      if (oldYear !== undefined && newYear !== oldYear) {
        this.loadDataForYear(newYear);
      }
    }
  },
  methods: {
    async loadFileList() {
      try {
        const response = await axios.get('https://xylo.codesinn.com/api/ftp/files');
        this.fileList = response.data.sort((a, b) => {
          // Convertir les dates en timestamps et trier
          return new Date(b.rawModifiedAt) - new Date(a.rawModifiedAt);
        });
      } catch (error) {
        console.error("Erreur lors de la récupération des fichiers : ", error);
      }
    },
    openSendUnpaidEmailPopup() {
      this.popupSendEmail = true;
    },
    formatDeadline(date) {
      if (!date) return '-';
      return moment(date).format('DD/MM/YYYY');
    },
    formatDateForPdfHeader() {
      return moment().format('DD.MM.YYYY');
    },
    buildEmailContent() {
      const today = moment().format('DD.MM.YYYY');
      const cell = 'padding:4px 6px;border-bottom:1px solid #eee;font-size:11px;';
      const th = cell + 'color:#616161;font-weight:700;';

      let html = `<div style="font-family:Arial,sans-serif;max-width:800px;margin:0 auto;">
<div style="background:#1a237e;padding:12px;text-align:center;"><h1 style="color:#fff;margin:0;font-size:18px;">Raport Facturi Neachitate</h1><p style="color:#c5cae9;margin:4px 0 0;font-size:12px;">${today} | Anul ${this.selectedYear}</p></div>
<div style="padding:10px;background:#f5f5f5;"><table style="width:100%;"><tr>
<td style="${cell}text-align:center;background:#fff;">Facturi: <b>${this.unpaidInvoices.length}</b></td>
${this.unpaidTotals.EUR > 0 ? `<td style="${cell}text-align:center;background:#fff;">Total EUR: <b>${this.formatNumber(this.unpaidTotals.EUR)}</b></td>` : ''}
${this.unpaidTotals.RON > 0 ? `<td style="${cell}text-align:center;background:#fff;">Total RON: <b>${this.formatNumber(this.unpaidTotals.RON)}</b></td>` : ''}
</tr></table></div>
<table style="width:100%;border-collapse:collapse;font-size:11px;">
<tr style="background:#fafafa;"><th style="${th}text-align:left;">Furnizor</th><th style="${th}text-align:left;">Factură</th><th style="${th}text-align:center;">Dată</th><th style="${th}text-align:center;">Termen</th><th style="${th}text-align:right;">Sumă</th></tr>`;

      this.unpaidInvoices.forEach((inv, i) => {
        const dl = inv.date_delivery_desired ? moment(inv.date_delivery_desired).format('DD.MM.YY') : '-';
        const over = inv.date_delivery_desired && moment(inv.date_delivery_desired).isBefore(moment());
        const bg = over ? '#fff3e0' : (i % 2 ? '#fafafa' : '#fff');
        const dlStyle = over ? 'color:#d32f2f;font-weight:600;' : '';
        html += `<tr style="background:${bg};"><td style="${cell}">${(inv.provider || '-').substring(0, 28)}</td><td style="${cell}">${inv.invoice_no || '-'}</td><td style="${cell}text-align:center;">${this.formatDateSPV(inv.data_creare)}</td><td style="${cell}text-align:center;${dlStyle}">${over ? '! ' : ''}${dl}</td><td style="${cell}text-align:right;font-weight:600;">${parseFloat(inv.amount_htva || 0).toFixed(2)} ${inv.currency}</td></tr>`;
      });

      html += `</table>
<div style="padding:8px 12px;background:#e8eaf6;text-align:right;border-top:2px solid #3949ab;">
${this.unpaidTotals.EUR > 0 ? `<b style="color:#1a237e;">${this.formatNumber(this.unpaidTotals.EUR)} EUR</b> ` : ''}${this.unpaidTotals.RON > 0 ? `<b style="color:#1a237e;">${this.formatNumber(this.unpaidTotals.RON)} RON</b>` : ''}
</div>
<p style="margin:8px 0 0;color:#9e9e9e;font-size:10px;text-align:center;">Xylo - ${today}</p></div>`;

      return html;
    },
    async sendUnpaidInvoicesEmail() {
      if (!this.emailRecipient || this.unpaidInvoices.length === 0) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: 'Please enter a valid email and ensure there are unpaid invoices.',
          position: 'bottom-center'
        });
        return;
      }

      this.$vs.loading();

      try {
        const { data } = await axios.post(
          'https://xylo.codesinn.com/api/paymentreminder/send-unpaid-invoices-email',
          { recipient: this.emailRecipient, year: this.selectedYear }
        );
        this.$vs.notify({
          color: 'success',
          title: 'Email sent successfully!',
          text: data.unpaidCount
            ? `Report with ${data.unpaidCount} unpaid invoices sent to ${this.emailRecipient}. PDF download link in the email.`
            : `No unpaid invoices for ${this.selectedYear}. Email not sent.`,
          position: 'bottom-center'
        });
        this.popupSendEmail = false;
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          color: 'danger',
          title: 'Email NOT sent!',
          text: (error.response && error.response.data && error.response.data.message) || error.message || 'Request failed',
          position: 'bottom-center'
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    formatNumber(value) {
      if (value === null || value === undefined) return '0';
      return parseFloat(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },
    getTotals() {
      let totals = {
        EUR: {
          totalExVAT: 0,
        },
        RON: {
          totalExVAT: 0,
        },
        NotPaid: {
          EUR: {
            totalExVAT: 0,
          },
          RON: {
            totalExVAT: 0,
          },
        },
        byMonth: {},
      };

      // Initialiser les totaux par mois
      for (let i = 1; i <= 12; i++) {
        totals.byMonth[i] = {
          EUR: { totalExVAT: 0 },
          RON: { totalExVAT: 0 },
        };
      }

      this.$store.state.BankList.downloadinvoicestreated.forEach(invoice => {
        const amountHTVA = parseFloat(invoice.amount_htva) || 0;

        // Extraire le mois de la date
        let month = null;
        if (invoice.data_creare && invoice.data_creare.length === 12) {
          month = parseInt(invoice.data_creare.substring(4, 6), 10);
        }

        // Ajouter aux totaux globaux sans conversion
        if (invoice.currency === 'EUR') {
          totals.EUR.totalExVAT += amountHTVA;
          if (month && month >= 1 && month <= 12) {
            totals.byMonth[month].EUR.totalExVAT += amountHTVA;
          }
        } else if (invoice.currency === 'RON') {
          totals.RON.totalExVAT += amountHTVA;
          if (month && month >= 1 && month <= 12) {
            totals.byMonth[month].RON.totalExVAT += amountHTVA;
          }
        }

        // Déterminer si la facture est "Not Paid"
        const isPaid =
          (invoice.paymentmeans && (invoice.paymentmeans === 1 || invoice.paymentmeans === 10)) || // Cash/POS
          (invoice.cif && ['2816464', '2864518', '18107744'].includes(invoice.cif.replace('RO', ''))) || // Clients spécifiques
          invoice.ispaid || // Directement payé
          invoice.count_transactions; // Transactions enregistrées

        if (!isPaid) {
          if (invoice.currency === 'EUR') {
            totals.NotPaid.EUR.totalExVAT += amountHTVA;
          } else if (invoice.currency === 'RON') {
            totals.NotPaid.RON.totalExVAT += amountHTVA;
          }
        }
      });

      // Formater les valeurs en f2
      totals.EUR.totalExVAT = totals.EUR.totalExVAT.toFixed(2);
      totals.RON.totalExVAT = totals.RON.totalExVAT.toFixed(2);
      totals.NotPaid.EUR.totalExVAT = totals.NotPaid.EUR.totalExVAT.toFixed(2);
      totals.NotPaid.RON.totalExVAT = totals.NotPaid.RON.totalExVAT.toFixed(2);

      // Formater les totaux par mois
      for (let i = 1; i <= 12; i++) {
        totals.byMonth[i].EUR.totalExVAT = totals.byMonth[i].EUR.totalExVAT.toFixed(2);
        totals.byMonth[i].RON.totalExVAT = totals.byMonth[i].RON.totalExVAT.toFixed(2);
      }

      return totals;
    },
    parseDate(dateString) {
      const [day, month, year] = dateString.split("/").map(Number);
      return new Date(year, month - 1, day); // Les mois commencent à 0
    },
    getRateFromMap(inputDate, ratesMap) {
      const [day, month, year] = inputDate.split('/');
      const targetDate = `${year}-${month}-${day}`;
      const previousDate = new Date(targetDate);
      previousDate.setDate(previousDate.getDate() - 1);

      let dateString = previousDate.toISOString().split('T')[0];

      // Parcourir les jours précédents si aucun taux direct n'est trouvé
      while (!ratesMap[dateString] && previousDate > new Date('2024-01-01')) {
        previousDate.setDate(previousDate.getDate() - 1);
        dateString = previousDate.toISOString().split('T')[0];
      }

      return ratesMap[dateString] || null; // Retourne le taux trouvé ou null
    },
    async fetchEURRates() {
      try {
        axios.get("https://xylo.codesinn.com/api/rates").then(response => {
          this.rates = response.data;
        });
      } catch (error) {
        console.error("Erreur lors de la récupération des taux :", error.message);
      }
    },
    getYearsRange() {
      const currentYear = new Date().getFullYear();
      const startYear = 2024; // Remplace par une année de début adaptée
      return Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i);
    },
    removeFilterNotPaid() {
      this.searchQuery = ''
      this.updateSearchQuery('')
    },
    filterNotPaid() {
      this.searchQuery = 'Not Paid'
      this.updateSearchQuery('Not Paid')
    },

    getCui(value) {
      if (value) {
        let cifBeneficiarRegex = /cif_emitent=(\d+)/;
        let match = value.match(cifBeneficiarRegex);
        let cifBeneficiar = match ? match[1] : null;
        if (cifBeneficiar) return cifBeneficiar
      }
    },
    formatDateSPVcall(dateStr) {
      if (dateStr && dateStr.length === 12) {
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const hour = dateStr.substring(8, 10);
        const minute = dateStr.substring(10, 12);
        const date = moment(`${year}-${month}-${day} ${hour}:${minute}`, 'YYYY-MM-DD HH:mm');
        return date.format('YYYY-MM-DD');
      } else {
        return 'Format de date invalide';
      }
    },
    formatDateSPV(dateStr) {
      if (dateStr && dateStr.length === 12) {
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const hour = dateStr.substring(8, 10);
        const minute = dateStr.substring(10, 12);
        const date = moment(`${year}-${month}-${day} ${hour}:${minute}`, 'YYYY-MM-DD HH:mm');
        return date.format('DD/MM/YYYY');
      } else {
        return 'Format de date invalide';
      }
    },
    format_dates(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).format("DD MMM YYYY");
      }
    },
    formatDate(dateString) {
      let date = new Date(dateString);
      let day = date.getDate().toString().padStart(2, '0');
      let month = (date.getMonth() + 1).toString().padStart(2, '0'); // Les mois sont indexés à partir de 0
      let year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    loadDataForYear(year) {
      this.$vs.loading();
      const selectedMonth = new Date().getMonth() + 1;
      this.$store.dispatch('BankList/downloadinvoicestreatedyear', { month: selectedMonth, year: year })
        .then(response => {
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Access Denied",
            text: "Please create a SPV TOKEN",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "bottom-center",
            time: 8000,
          });
          console.error(err);
          this.$vs.loading.close();
        });
    }
  },
  async mounted() {
    this.gridApi = this.gridOptions.api
    await this.fetchEURRates();

  },
  created() {
    this.loadFileList()
    if (!moduleBankList.isRegistered) {
      this.$store.registerModule('BankList', moduleBankList)
      moduleBankList.isRegistered = true
    }
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }

    try {
      const selectedMonth = new Date().getMonth() + 1; // Remplace `this.selectedMonth` par la variable liée au mois sélectionné
      this.$store.dispatch('BankList/downloadinvoicestreatedyear', { month: selectedMonth, year: this.selectedYear })
        .then(response => {
          this.$vs.loading.close();
        })
        .catch(err => {
          this.$vs.notify({
            title: "Access Denied",
            text: "Please create a SPV TOKEN",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "bottom-center",
            time: 8000,
          });
          console.error(err);
          this.$vs.loading.close();
          this.$router.push({ path: "/settings/menu" });
        });
    } catch (error) {
      console.error("Error in component created hook:", error);
    }
  },
}

</script>

<style lang="scss">
.totals-container {
  max-width: 600px;
  margin: 20px auto;
  font-family: Arial, sans-serif;
}

.totals-section {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #f9f9f9;
}

.totals-section.not-paid {
  background-color: #ffe6e6;
  border-color: #ff4d4d;
}

.totals-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}

.totals-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.totals-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  font-size: 1rem;
  color: #555;
}

.currency-label {
  font-weight: bold;
  color: #333;
  margin-right: 8px;
}

.monthly-totals {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #ddd;
}

.monthly-title {
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 12px;
  color: #333;
}

.monthly-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
}

.month-item {
  background-color: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px;
  font-size: 0.9rem;
}

.month-name {
  font-weight: bold;
  color: #555;
  margin-bottom: 6px;
  font-size: 0.85rem;
}

.month-values {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.month-value {
  font-size: 0.8rem;
  color: #666;
}

#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}


.context-menu {
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
}

.context-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.context-menu ul li {
  padding: 10px;
  cursor: pointer;
}

.context-menu ul li:hover {
  background-color: #f0f0f0;
}

/* Popup send unpaid email */
.unpaid-email-popup-content {
  min-width: 520px;
  max-width: 640px;
}
.unpaid-pdf-summary {
  background: #eceff1;
  border: 1px solid #cfd8dc;
  border-radius: 4px;
  padding: 10px 14px;
  font-size: 0.9rem;
  color: #263238;
  margin-bottom: 12px;
}
.unpaid-pdf-table-wrap {
  max-height: 280px;
  overflow-y: auto;
  border: 1px solid #cfd8dc;
  border-radius: 4px;
}
.unpaid-pdf-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}
.unpaid-pdf-table-header {
  background: #37474f;
  color: #fff;
  font-weight: 600;
  text-align: left;
  padding: 10px 10px;
}
.unpaid-pdf-table-header th:last-child {
  text-align: right;
}
.unpaid-pdf-row td {
  padding: 8px 10px;
  border-bottom: 1px solid #cfd8dc;
  color: #212121;
}
.unpaid-pdf-row-alt {
  background: #f5f5f5;
}
.unpaid-pdf-note {
  margin-top: 8px;
  font-size: 0.8rem;
  color: #607d8b;
}
.unpaid-pdf-footer {
  margin-top: 12px;
  font-size: 0.85rem;
  color: #78909c;
  text-align: center;
}
.unpaid-pdf-actions {
  padding: 12px 16px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
</style>
